import { render, staticRenderFns } from "./quiz-diva.vue?vue&type=template&id=5802383c&scoped=true"
import script from "./quiz-diva.vue?vue&type=script&lang=js"
export * from "./quiz-diva.vue?vue&type=script&lang=js"
import style0 from "./quiz-diva.vue?vue&type=style&index=0&id=5802383c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5802383c",
  null
  
)

export default component.exports